var _rect, _rect2, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHighImg = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 25,
    viewBox: "0 0 92 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.288863,
    y: 0.288863,
    width: 91.4223,
    height: 24.4223,
    rx: 5.48839,
    fill: "url(#paint0_radial_155_57)",
    fillOpacity: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.288863,
    y: 0.288863,
    width: 91.4223,
    height: 24.4223,
    rx: 5.48839,
    stroke: "#17B9FF",
    strokeOpacity: 0.1,
    strokeWidth: 0.577726
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.288863,
    y: 0.288863,
    width: 91.4223,
    height: 24.4223,
    rx: 5.48839,
    stroke: "url(#paint1_linear_155_57)",
    strokeWidth: 0.577726,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4602 16.3809V6.17486H32.6502V10.6829H38.8242V6.17486H40.0142V16.3809H38.8242V11.7329H32.6502V16.3809H31.4602ZM42.3921 7.81286V6.17486H43.5261V7.81286H42.3921ZM42.3921 16.3809V9.03086H43.5261V16.3809H42.3921ZM48.4737 18.8589C47.643 18.8589 46.9664 18.6769 46.4437 18.3129C45.921 17.9489 45.6177 17.4495 45.5337 16.8149H46.6397C46.705 17.1789 46.901 17.4635 47.2277 17.6689C47.5637 17.8835 47.9884 17.9909 48.5017 17.9909C49.1924 17.9909 49.7337 17.8322 50.1257 17.5149C50.5177 17.2069 50.7137 16.6702 50.7137 15.9049V14.3789H50.6297C50.4617 14.8549 50.1537 15.2375 49.7057 15.5269C49.267 15.8162 48.7397 15.9609 48.1237 15.9609C47.2184 15.9609 46.495 15.6482 45.9537 15.0229C45.4124 14.3975 45.1417 13.5342 45.1417 12.4329C45.1417 11.3222 45.417 10.4589 45.9677 9.84286C46.5184 9.21753 47.2464 8.90486 48.1517 8.90486C48.7584 8.90486 49.281 9.04953 49.7197 9.33886C50.1584 9.62819 50.4617 10.0062 50.6297 10.4729H50.7137L50.7417 9.03086H51.8337V15.8069C51.8337 16.5442 51.6937 17.1369 51.4137 17.5849C51.1337 18.0329 50.7417 18.3549 50.2377 18.5509C49.7337 18.7562 49.1457 18.8589 48.4737 18.8589ZM48.4877 15.0649C48.9637 15.0649 49.365 14.9575 49.6917 14.7429C50.0184 14.5282 50.2704 14.2529 50.4477 13.9169C50.625 13.5809 50.7137 13.2355 50.7137 12.8809V11.9849C50.7137 11.6302 50.625 11.2895 50.4477 10.9629C50.2797 10.6269 50.0324 10.3515 49.7057 10.1369C49.379 9.92219 48.9777 9.81486 48.5017 9.81486C47.8297 9.81486 47.293 10.0482 46.8917 10.5149C46.4997 10.9815 46.3037 11.6209 46.3037 12.4329C46.3037 13.2729 46.5044 13.9215 46.9057 14.3789C47.307 14.8362 47.8344 15.0649 48.4877 15.0649ZM53.9038 16.3809V6.17486H55.0238V10.5569H55.1078C55.3318 10.0155 55.6772 9.60953 56.1438 9.33886C56.6105 9.05886 57.1192 8.91886 57.6698 8.91886C58.1832 8.91886 58.6358 9.02153 59.0278 9.22686C59.4292 9.43219 59.7418 9.76819 59.9658 10.2349C60.1992 10.6922 60.3158 11.2989 60.3158 12.0549V16.3809H59.1818V12.2789C59.1818 11.4482 59.0278 10.8415 58.7198 10.4589C58.4118 10.0669 57.9405 9.87086 57.3058 9.87086C56.8485 9.87086 56.4472 9.98286 56.1018 10.2069C55.7565 10.4309 55.4905 10.7342 55.3038 11.1169C55.1172 11.4902 55.0238 11.9195 55.0238 12.4049V16.3809H53.9038Z",
    fill: "#F1B503"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_155_57",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.1719 1.07422) rotate(42.715) scale(40.597 47.4035)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC003"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.780575,
    stopColor: "#1C1B33",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_155_57",
    x1: 4.22703,
    y1: 2.46771e-7,
    x2: 7.74283,
    y2: 20.5194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHighImg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/high-img.9c1fa8785cdb52627bb34da5a53b8aee.svg";